<template lang="html">
  <div class="comment-success" :class="{ isMP: inMinProgram }">
    <div class="success-info">
      <p>
        <img src="../../assets/images/comment-success.png" alt="" />
      </p>
      <p>评论成功!</p>
      <p v-if="!inMinProgram">
        <button @click="backOrderList">返回订单列表</button>
        <button class="share" v-show="showShare" @click="goShare">
          分享评论
        </button>
      </p>
      <div class="promotion" v-if="posters.length > 0 && !inMinProgram">
        <banner class="poster" :height="200" :posters="posters"></banner>
      </div>
    </div>
    <!-- <serviceProduct v-if="commentSettings.comment_products" :key="index" v-for="(item,index) in commentSettings.comment_products" :serviceProduct="item"></serviceProduct> -->
    <div class="sku-list" v-if="!inMinProgram">
      <h2>育儿服务</h2>
      <skuList :showFilter="showFilter"></skuList>
    </div>
    <div id="dialog_content" v-if="!inMinProgram">
      <div class="comment-success-info">
        <p>
          <img src="../../assets/images/comment-success.png" alt="" />
        </p>
        <p>评论成功</p>
        <p>感谢您的精彩评论，系统为您生成了画布，是否查看？</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Msgbox } from 'kf-component-vue'
import banner from '@/components/promotion'
import skuList from '@/components/product/index'

export default {
  data() {
    return {
      showShare: false,
      posters: [],
      showFilter: false
    }
  },
  async created() {
    this.$$title('评论成功')
    const device = this.$$getDevice()
    const version = parseFloat(this.$$cookie('version'), 10)
    await this.$store.dispatch('getCommentSettings')
    const comment_show = this.$$cookie('vshowCommentDialog')
    if (
      (device === 'ios' && version >= 4.6) ||
      (device === 'android' && version >= 45)
    ) {
      this.showShare = true
      if (!comment_show) {
        this.showDialog()
      }
    }
    this.$$loading(false)
    // console.log(msgbox);
  },
  mounted() {
    this.getPromotions()
  },
  methods: {
    backOrderList() {
      this.$$tracker('110803', '20000', 21092)
      location.href = '/v/user/order?cmd=share&sharetype=0'
    },
    async getPromotions() {
      const promotions = await this.$store.dispatch('getPagePromotions')
      const page = promotions.data.commentResult
      if (page && page.promotions) {
        this.posters = page.promotions
      }
    },
    goShare() {
      const sku_id = this.$route.query.sku_id || ''
      // this.$router.push({
      //     name: 'comment-share',
      //     query: {
      //         sku_id
      //     }
      // })
      this.$$tracker('110803', '20000', 21093)
      const query = this.$$queryString.stringify({
        spuId: this.$route.query.spuId,
        // entity_id: this.$route.query.entity_id,
        // channel_id: this.$route.query.channel_id,
        home_worker_uid: this.$route.query.home_worker_uid,
        cmd: 'share',
        sharetype: 0,
        refresh: 'no'
      })
      location.href = `/v/order/${this.$route.params.orderCode}/comment/share?${query}`
    },
    hideDialog() {},
    showDialog() {
      Msgbox({
        title: '',
        message: document.querySelector('#dialog_content').innerHTML,
        showCancelButton: true,
        confirmButtonText: '好',
        cancelButtonText: '取消',
        confirmButtonClass: 'comment-confirm',
        type: 'confirm',
        action: msgbox => {
          this.goShare()
          this.$$tracker('110803', '20000', 21064)
          const mainName = location.hostname.replace(
            /^.*?(\..*)/,
            function replace(a, b) {
              return b
            }
          )
          this.$$cookie.set('vshowCommentDialog', 'true', {
            expires: 1 / 24 / 4,
            domain: mainName
          })
        },
        cancel: msgbox => {
          this.$$tracker('110803', '20000', 21063)
          const mainName = location.hostname.replace(
            /^.*?(\..*)/,
            function replace(a, b) {
              return b
            }
          )
          this.$$cookie.set('vshowCommentDialog', 'true', {
            expires: 1 / 24 / 4,
            domain: mainName
          })
        }
        // callback: (action) => {
        //     if (action === 'confirm') {
        //         this.goShare();
        //         this.$$tracker('110803', '20000', 21064)
        //     } else {
        //         this.$$tracker('110803', '20000', 21063)
        //     }
        //     const mainName = location.hostname.replace(/^.*?(\..*)/, function replace(a, b) {
        //         return b
        //     })
        //     this.$$cookie.set('vshowCommentDialog', 'true', { expires: 1 / 24 / 4, domain: mainName })
        // }
      })
    }
  },
  computed: {
    ...mapState(['commentSettings', 'inMinProgram', 'isMinProgram'])
  },
  components: {
    banner,
    skuList
    // serviceProduct
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.isMP {
  min-height: 100%;
  background: #fff;

  .success-info {
    padding-top: 40%;
  }
}
.comment-success {
  .success-info {
    background: #fff;
    text-align: center;

    > p:first-of-type {
      padding-top: rem(50px);

      img {
        width: rem(200px);
      }
    }
    > p:nth-of-type(2) {
      margin-top: rem(20px);
      font-size: rem(36px);
    }
    > p:nth-of-type(3) {
      margin-top: rem(40px);
      padding-bottom: rem(60px);
      font-size: rem(36px);

      button {
        width: rem(206px);
        height: rem(60px);
        line-height: rem(60px);
        font-size: rem(26px);
        color: #666;
        @include border(all, #d2d2d2);

        &.share {
          background: #ff397e;
          color: #fff;
          margin-left: rem(50px);

          &::before {
            border: none;
          }
        }
      }
    }
    .promotion {
      .poster {
        height: rem(200px);
      }
    }
  }
}
.comment-success-info {
  background: #fff;
  text-align: center;
  > p {
    line-height: 1.2;
  }
  > p:first-of-type {
    img {
      width: rem(200px);
    }
  }
  > p:nth-of-type(2) {
    margin-top: rem(20px);
    font-size: rem(36px);
    color: #ff397e;
  }
  > p:nth-of-type(3) {
    margin-top: rem(20px);
    font-size: rem(26px);
    color: #666;
    line-height: 1.3;
    text-align: left;
  }
  > p:nth-of-type(4) {
    margin-top: rem(40px);
    padding-bottom: rem(60px);
    font-size: rem(36px);

    button {
      width: rem(260px);
      height: rem(88px);
      line-height: rem(88px);
      font-size: rem(28px);
      color: #666;
      @include border(all, #d2d2d2);

      &.share {
        background: #ff397e;
        color: #fff;
        margin-left: rem(40px);

        &::before {
          border: none;
        }
      }
    }
  }
}
.sku-list {
  padding-top: rem(20px);
  background: #f4f4f4;
  h2 {
    text-align: center;
    font-weight: 600;
    font-size: rem(30px);
    padding: rem(20px) rem(15px);
    background: #fff;
    @include border(bottom, #e5e5e5);
  }
}
#dialog_content {
  display: none;
}
</style>
<style>
.comment-confirm.comment-confirm {
  color: #ff397e;
}
</style>
